import { Checkbox, FormControlLabel } from "@mui/material";
import type { FC } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { useSupabaseLoader } from "../../../server/supabase/hooks";
import type { MomentFormMoment } from "../../moment/types/moment-form-moment";
import type { ToFormProps } from "./to-forms/types";

export const TeamsChannelNotify: FC<ToFormProps> = ({ formDisabled }) => {
  const { control } = useFormContext<MomentFormMoment>();

  const { loading: integrationLoading, data: integration } = useSupabaseLoader(
    async ({ supabase }) => {
      const { data, error } = await supabase.from("teams_integration").select().maybeSingle();
      if (error) throw error;

      return data;
    },
    [],
  );

  if (integrationLoading || !integration?.allow_channel_message_notify) return null;

  return (
    <Controller
      name="teams_channel_message_notify"
      control={control}
      render={({ field }) => (
        <FormControlLabel
          control={<Checkbox {...field} disabled={formDisabled} defaultChecked={field.value} />}
          label="Send a notification to all members of the chosen Teams channels."
        />
      )}
    />
  );
};
